export default __webpack_public_path__ + "static/media/baliram-pansare.e2715f6b.PNG";